import React from "react";

const TitleText = ({ title }) => {
	return (
		<h3 className="text-4xl font-semibold text-violet-900 uppercase">
			{title}
		</h3>
	);
};

export default TitleText;
